
import React from "react";
import Box from "@material-ui/core/Box";
import {
  Button,
  Dialog,
  DialogContent,
  Slide,
} from "@material-ui/core";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { TASK_STATUS_OBJ } from "__helpers/constants";
import { localDateFormat } from "__helpers/util";
import { PATIENT_LIST } from "__helpers/constants";
import notesArrow from "assets/img/icons/notes-arrow.svg";
import { Scrollbars } from "react-custom-scrollbars";
import { USER_INFO } from "__helpers/constants";
import PatientTasks from "./PatientTasks";
import { apiPath } from "api";
import { generalAuthTokenHeader } from "__helpers/auth-header";
import { getActiveFacility } from "__helpers/activeFacility";
const mapStateToProps = (state) => {
  return {
    insuranceListRedux: state.insuranceList,
    hospitalListRedux: state.hospitalList,
    languageAndInsuranceList: state.getPatientLanNInsList,
    categoryListRedux: state.categoryList,
  };
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});
class PatientTaskList extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.addressStreetInputRef = React.createRef();
    let userInfo = JSON.parse(localStorage.getItem(USER_INFO));
    const sessionPatientList = JSON.parse(sessionStorage.getItem(PATIENT_LIST)) || {};
    const __activeFacility = getActiveFacility() || {};
    console.log(__activeFacility.address);
    this.state = {
      languageAndInsuranceList: this.props.languageAndInsuranceList,
      hospitalList: this.props.hospitalListRedux
        ? this.props.hospitalListRedux
        : [],
      categoryList: this.props.categoryListRedux,
      patientInfo: this.props.patientInfo,
      categoryName: "",
      selectedCategory: "",
      selectedService: [],
      selectSubService: [],
      subService: false,
      subServices: [],
      insurance: "",
      userInsurance:
        this.props.patientInfo && this.props.patientInfo.insuranceId
          ? "" + this.props.patientInfo.insuranceId
          : "0",
      userHospital:
        this.props.patientInfo && this.props.patientInfo.previousHospitalId
          ? this.props.patientInfo.previousHospitalId
          : "",
      hospital: [""],
      language: [""],
      infectiousDisease: "",
      patientCriteria: [],
      patientTaskModalStatus: false,
      reduxLoadFlag: false,
      confirmBoxStatus: false,
      readOnly: this.props.readOnly ? this.props.readOnly : false,
      selectedCategoryId: "",
      isInsuranceFiltered: true,
      openTaskModal: false,
      mile: 50,
      longitude: "",
      latitude: "",
      patientList:null,

      address: userInfo ? __activeFacility.address : "",
      defaultAddress: userInfo
        ? __activeFacility.address
        : "",
      defaultLatitude: userInfo
        ? __activeFacility.latitude
        : "",
      defaultLongitude: userInfo
        ? __activeFacility.longitude
        : "",
    };
    this.fetchPatient = this.fetchPatient.bind(this);
    this.loaderStatus = this.loaderStatus.bind(this);
    this.updatePatientModalClose = this.updatePatientModalClose.bind(this);

  }


  openTaskModal(taskId) {
    this.setState({
      openTaskModal: true,
      patientTaskId: taskId,
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.patientList !== this.props.patientList && this.props.patientList) {
      this.setState({ patientList: this.props.patientList });
    }
  }
  patientTaskModalOpen = () => {
    this.setState({
      patientTaskModalStatus: true,
    });
  };
  
  patientTaskModalClose = () => {
    this.setState({
      patientTaskModalStatus: false,
    });
  };
  
  async fetchPatient(patientId) {
    try {
      if (!patientId) {
        patientId = JSON.parse(localStorage.getItem("_selected_patient_list"));
      }
      
  
      localStorage.setItem("SELECTED_PATIENT_LIST", JSON.stringify(patientId));
  
      const apiUrl = `${apiPath.getPatientList}/${patientId}`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(), // Ensure this returns an object like { Authorization: 'Bearer token' }
      });
   
   
      const result = await response.json();
      console.log("json response:", result);
      if (result) {
        const patient = result[0];
        const tasks =  patient.patientTask || []; // Adjust this to match your exact field
  
        this.setState({
          patientList: patient,
          patientTaskList: tasks,
        });
  
        console.log("Fetched patient:", patient);
        console.log("Fetched tasks:", tasks);
      } else {
        console.error("API returned failure:", result.message);
      }
    } catch (error) {
      console.error("Error in fetchPatient:", error);
    }
  }
  

  componentDidMount() {
    console.log("Component mounted");
    const patientId = this.props.selectedPatientId || null;
     this.fetchPatient(patientId);

    // Optional: open modal if task_id exists in localStorage
    const taskId = localStorage.getItem("task_id");
    if (taskId) {
      this.openTaskModal(taskId);
      localStorage.removeItem("task_id");
    }
  }
 updatePatientModalClose = () => {
    let patientList = JSON.parse(localStorage.getItem(PATIENT_LIST));
    this.setState({
      patientModalStatus: false,
      openTaskModal: false,
      patientItemList: patientList,
    });
  };
  loaderStatus = (status) => {
    this.setState({
      loading: status,
    });
  };

  render() {
    const { patientTaskList } = this.state;
    const { classes } = this.props;
    return (
      <div className="pos-rel FilterDiv">
        <Dialog
          open={this.state.patientTaskModalStatus}
          maxWidth={"sm"}
          onClose={this.patientCriteriaModalClose}
          aria-labelledby="provider-dialog-title"
          className="add-modal front-modal LevelCriteria "
          
        >
         <Scrollbars style={{ height: "700px" }} universal={true}>
  <form onSubmit={this.openConfirmBox} noValidate>
    <DialogContent>
      <div className="addbtn-cover" style={{ textAlign: "start", marginBottom: "10px",left:"50px" }}>
        <Button
          className="pointer btn1 addbtn"
          onClick={(e) => this.openTaskModal("")}
          disabled={this.state.loading}
        >
          + Add New
        </Button>
      </div>

      <div className="section tasks-cover-all-new">
        <table className="task-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            {(() => {
              const taskData = this.state.patientList?.patientTask;
              console.log("taskData:", taskData);
              if (Array.isArray(taskData) && taskData.length > 0) {
                return taskData.map((tList, key) => (
                  <tr
                    key={key}
                    className={`task-name ${TASK_STATUS_OBJ[tList.changeStatus]}`}
                    style={{ borderBottom: "1px solid #ccc", cursor: "pointer" }}
                    onClick={() => this.openTaskModal(tList.id)}
                  >
                    <td style={{ padding: "10px" }}>
                      {tList.taskName}
                      {tList.dueDate ? ` - ${localDateFormat(tList.dueDate)}` : ""}
                    </td>
                  </tr>
                ));
              } else {
                return (
                  <tr>
                    <td className="no-tasks" style={{ padding: "10px" }}>No Tasks!</td>
                  </tr>
                );
              }
            })()}
          </tbody>
        </table>
      </div>
    </DialogContent>
  </form>
</Scrollbars>

        </Dialog>
        {this.state.patientList &&(
         <PatientTasks
                  openTaskModal={this.state.openTaskModal}
                  updatePatientModalClose={this.updatePatientModalClose}
                  patientCategoryList={this.state.patientCategoryList}
                  patientDetail={this.state.patientList}
                  
                  loaderStatus={this.loaderStatus}
                  patientTaskId={this.state.patientTaskId}
                  refreshTasks={() => this.fetchPatient(this.state.patientList?.id)} // ✅ Pass this function

                />
        )}
      </div>
    );
  }
}
export const PatientTaskListClass = connect(mapStateToProps)(PatientTaskList);
export default PatientTaskListClass;
